import React, { useEffect, useState } from 'react';
import { useParams, useLocation, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

import { agent } from 'helpers/agent';
import { API_MYEDUZZ } from 'settings';
import GlobalLoading from 'v2/components/Shared/GlobalLoading';

interface IRouteProps {
  provider: 'mailchimp' | 'aweber' | 'infusionsoft' | 'rd_station';
  description: string;
}

const ProviderValidation = () => {
  const [redirect, setRedirect] = useState<boolean>(false);
  const [id, setId] = useState<string>();
  const { provider } = useParams<IRouteProps>();
  const { search } = useLocation();

  useEffect(() => {
    const description = localStorage.getItem('connect-description');
    const queryString = new URLSearchParams(search);

    if (provider && provider === 'aweber') {
      const oauthToken = queryString.get('oauth_token');
      const oauthVerifier = queryString.get('oauth_verifier');

      if (oauthToken) {
        agent
          .post(`${API_MYEDUZZ}/connect/validate/aweber`, {
            oauth_token: oauthToken,
            oauth_verifier: oauthVerifier,
            description
          })
          .then(response => {
            const { id } = response.data.data;
            toast.success('Connect criado com sucesso');
            setId(id);
            setRedirect(true);
          })
          .catch(() => {
            toast.error('Ocorreu um erro ao tentar cadastrar connect');
            setRedirect(true);
          });
        return;
      }
    }

    const code = queryString.get('code');

    if (provider && code) {
      agent
        .post(`${API_MYEDUZZ}/connect/validate/${provider}`, { code, description })
        .then(response => {
          const { id } = response.data.data;
          toast.success('Connect criado com sucesso');
          setId(id);
          setRedirect(true);
        })
        .catch(() => {
          toast.error('Ocorreu um erro ao tentar cadastrar connect');
          setRedirect(true);
        });
    }
  }, [provider, search]);

  if (redirect) {
    if (id) return <Redirect to={`/producer/connect/${id}/actions`} />;
    return <Redirect to='/producer/connect/myconnects' />;
  }

  return <GlobalLoading />;
};
export default ProviderValidation;
